import React, { useState } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import DashboardTopNav from './DashboardTopNav';
import DashboardNav from './DashboardNav';
import DashboardFollowers from './DashboardFollowers';
import DashboardLikes from './DashboardLikes';
import DashboardMessaging from './DashboardMessaging';
import DashboardAutoRelist from './DashboardAutoRelist';
import DashboardBoostReviews from './DashboardBoostReviews';
import DashboardSettings from './settings/DashboardSettings';
import SettingsChangeDepop from './settings/SettingsChangeDepop';
import SettingsCancelSubscription from './settings/SettingsCancelSubscription';
import SettingsSubscriptionCancelled from './settings/SettingsSubscriptionCancelled';
import PaymentFailed from './PaymentFailed';

import '../../styles/dashboard/Dashboard.css';

export default function Dashboard({ history, handleLogOut }) {
    const [mobileActive, setMobileActive] = useState(false);
    
    const handleMobileMenu = (e) => {
        e.preventDefault();
        setMobileActive(!mobileActive);
    };

    return (
        <div className="Dashboard">
            <DashboardTopNav 
            history={history}
            mobileActive={mobileActive}
            handleMobileMenu={handleMobileMenu}
            handleLogOut={handleLogOut} />
            <div className="DashboardContent">
                <DashboardNav
                history={history}
                mobileActive={mobileActive}
                handleMobileClose={handleMobileMenu} 
                handleLogOut={handleLogOut} />
                <Switch>
                    <Route
                    exact
                    path="/dashboard"
                    render={props => 
                    <Redirect
                    to={{
                        pathname: '/dashboard/followers',
                        state: { from: props.location }
                    }} />
                } />
                <Route 
                exact
                path="/dashboard/followers" 
                component={DashboardFollowers} />
                <Route
                exact
                path="/dashboard/likes"
                component={DashboardLikes} />
                <Route
                exact
                path="/dashboard/messaging"
                component={DashboardMessaging} />
                <Route
                exact
                path="/dashboard/autorelist"
                component={DashboardAutoRelist} />
                <Route
                exact
                path="/dashboard/boostreviews"
                component={DashboardBoostReviews} />
                <Route
                exact
                path="/dashboard/settings/depop/changedepop"
                component={SettingsChangeDepop} />
                <Route
                exact
                path="/dashboard/settings/cancelsubscription"
                component={SettingsCancelSubscription} />
                <Route
                exact
                path="/dashboard/settings/subscriptioncancelled"
                component={SettingsSubscriptionCancelled} />
                <Route 
                exact
                path="/dashboard/paymentfailed"
                component={PaymentFailed} />
                <Route
                path="/dashboard/settings"
                component={DashboardSettings} />
                
            </Switch>
            </div>
             
            
        </div>
     )
}